import type { ChoiceItem } from "./choice";
import { OptionButton } from "./OptionButton";

/**
 * Which kind of choice the grid holds. It only picks a BEM modifier today, but
 * it keeps each grid findable by its role in DevTools — which a shared
 * `.option-grid` alone would not.
 */
export type OptionGridVariant = "material" | "armrest" | "accessory" | "model";

type Props = {
  items: ChoiceItem[];
  onSelect: (id: string) => void;
  variant: OptionGridVariant;
  /**
   * Multi-select: several items can be on at once and `onSelect` toggles the
   * one clicked. Single-select is the default.
   */
  multiple?: boolean;
};

/**
 * The grid every non-swatch option group renders in. One component rather than
 * three near-identical ones: they differed only in a modifier class and in
 * whether a click picks or toggles, and both are props.
 */
export function OptionGrid(props: Props) {
  return (
    <div className={`option-grid ${props.variant}-grid`}>
      {props.items.map((item) => (
        <OptionButton
          key={item.id}
          isActive={item.selected}
          label={item.label}
          onClick={() => props.onSelect(item.id)}
        />
      ))}
    </div>
  );
}
